import { gql } from '@apollo/client';

const GET_USER_CLASSROOMS = gql`
  query getUserClassrooms(
    $whereUser: UsersWhereInput
    $whereLicense: LicenseUsageWhereInput
    $whereClassroom: ClassroomsWhereInput
  ) {
    classrooms(whereUser: $whereUser, where: $whereClassroom) {
      id
      name
      color
      studentCount
      users {
        user {
          firstName
          lastName
        }
        userId
        classroomRoles {
          name
          id
          displayName
        }
      }
      licenseUsage(where: $whereLicense) {
        productCurriculumId
        productCurriculum {
          id
          name
          iconUrl
          bannerUrl
          color
        }
      }
    }
  }
`;

export default GET_USER_CLASSROOMS;
